export default __webpack_public_path__ + "static/media/updown.99ef4181.svg";